export default {
    state: {
        config: {},
    },

    getters: {
        config: state => state.config,
    },

    actions: {
        async getConfig({ commit, dispatch }) {
            let r = await dispatch('doRequest', {
                endpoint: '/api/v3/ui/config',
                method: 'GET',
                body: null,
            })
            commit('commitConfig', r)
        },

        async updateConfig({ dispatch }, local_config) {
            await dispatch('doRequest', {
                endpoint: '/api/v3/ui/config',
                method: 'POST',
                body: JSON.stringify(local_config)
            })
            dispatch('getConfig')
        },
    },

    mutations: {
        commitConfig(state, config) {
            state.config = { ...state.config, ...config }
        }
    }
}